import React, { StrictMode } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { HelmetContext, Helmet, Provider as HelmetProvider } from '@okapi/helmet-react';
import { RenderCallback } from '@okapi/core';
import { GlobalRouter, Router } from '@okapi/router-react';
import { Provider as RemoteProvider } from '@okapi/remote';
import { UserAgentContext } from 'pages/frame/frame.context';
import { App } from 'app';

export type EntryProps = { router: GlobalRouter; remoteContext?: RenderCallback['remoteContext'] } & (
  | ClientSideEntryProps
  | ServerSideEntryProps
);

type ClientSideEntryProps = {
  helmetContext?: HelmetContext;
  router: GlobalRouter;
  store: Store;
  remoteContext?: RenderCallback['remoteContext'];
  userAgent?: Navigator['userAgent'];
};

type ServerSideEntryProps = {
  helmetContext?: HelmetContext;
  router: GlobalRouter;
  store: Store;
  remoteContext?: RenderCallback['remoteContext'];
  userAgent?: Navigator['userAgent'];
};

export function createEntry({ router, helmetContext, remoteContext, store, userAgent }: EntryProps) {
  return () => (
    <Router router={router}>
      <StrictMode>
        <HelmetProvider context={helmetContext}>
          <Provider store={store}>
            <RemoteProvider context={remoteContext}>
              <UserAgentContext.Provider value={userAgent ?? null}>
                <App />
              </UserAgentContext.Provider>
              <Helmet>
                <html lang="ru" />
                <title>Планировщик систем хранения</title>
                <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
                <meta name="description" content="Планировщик систем хранения" />
                <meta content="#444b5b" name="theme-color" />
                <link href="//fonts.googleapis.com" rel="dns-prefetch" />
                <link href="https://cdn.leroymerlin.ru/" crossOrigin="anonymous" rel="preconnect" />
                <link href="https://www.googletagmanager.com" crossOrigin="anonymous" rel="preconnect" />
                <link href="https://www.google-analytics.com" crossOrigin="anonymous" rel="preconnect" />
                <link href="https://fonts.gstatic.com" crossOrigin="anonymous" rel="preconnect" />
              </Helmet>
            </RemoteProvider>
          </Provider>
        </HelmetProvider>
      </StrictMode>
    </Router>
  );
}
